import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Sidebar.scss';

const Sidebar = () => {
  return (
    <Link to="/about" className="sidebar-link">
      <div className="sidebar">
        <h1 className="sidebar-title">JACOB RULEAUX</h1>
        <p className="sidebar-text">
        Designer, developer, adventurer—always exploring new possibilities. I’ve traveled far, lived abroad, and find joy in connecting with people, seeking out nature’s beauty, and solving problems in innovative ways. I’m passionate about learning and expanding my skills, drawing inspiration from art, history, and the world around me. Being artistic fuels my work and helps me bring unique perspectives to every project.
        </p>
      </div>
    </Link>
  );
};

export default Sidebar;
